import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import "dayjs/locale/pt-br";
import { pdf } from "@react-pdf/renderer";
import { useEffect, useState } from "react";

import api from "../../services/api";

import { useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import { renderToStaticMarkup } from "react-dom/server";
import PDFPieChart from "../pdfSlaCharts/pieChart";
import { useTheme } from "@mui/system";
import { PageTemplateEasyReport } from "../generateReport";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(localizedFormat);
dayjs.locale("pt-br");

export default function RelatorioDisponibilidadePdfEmail() {
  // Obter dados da URL
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const dadosString = searchParams.get("dados");
  const dadosDecodificados = JSON.parse(decodeURIComponent(dadosString));
  // States
  const [blobString, setBlobString] = useState(null);
  const [triggered, setTriggered] = useState(false);
  // Estilos
  const theme = useTheme();

  useEffect(() => {
    if (!triggered) {
      handleDados();
      setTriggered(true);
    }
  }, []);

  // Gerar relatório
  const handleDados = async () => {
    try {
      // Obter configurações de cabeçalho
      const config = await api.post("/find/generalSetting", {
        product: "usageReport",
      });
      const logo = config?.data?.imagem
        ? await handleUrlToBase64({ url: config?.data?.imagem })
        : null;
      const generalSettings =
        Object.keys(config?.data)?.length > 0
          ? {
              logo: logo,
              ...config?.data,
            }
          : {};
      // Obter json do relatório gerado
      const report = await api.post("/find/historyReport", {
        id: dadosDecodificados?.id,
      });

      const content = report?.data || {};

      const rfos = content?.rfos?.rfos || {};
      const totalTickets = content?.rfos?.totalTickets || 0;
      const availability = content?.availability || 0;
      const alerts = content?.alerts || null;

      const selectPages = {
        availability: true,
      };

      // Obtenção do gráfico de disponibilidade
      const graphcs = {
        availability: "",
      };
      const graphAvailability = await handleGenerateGraphPNG({
        chart: <WrapPieChart data={availability} />,
        width: 400,
        height: 260,
      });
      graphcs.availability = graphAvailability;

      // Criar arquivo PDF
      const MyDoc = (
        <PageTemplateEasyReport
          relatorio={{
            source: `Monitoramento ${
              window?.config?.REACT_APP_NAME_ENTERPRISE ||
              process.env.REACT_APP_NAME_ENTERPRISE
            }`,
            createdAt: dayjs().tz("America/Sao_Paulo"),
            dataInicial: content?.initialDate,
            dataFinal: content?.finalDate,
            client:
              content?.cliente?.razaoSocial ||
              content?.cliente?.nomeFantasia ||
              "",
            alerts: alerts,
          }}
          enterpriseConfig={{ ...generalSettings }}
          selectPages={selectPages}
          rfos={rfos}
          totalTickets={totalTickets}
          graphcs={graphcs}
        />
      );

      // Gerar o PDF como Blob e converter para base64
      const blob = await pdf(MyDoc).toBlob();
      const blobAsBase64 = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          const base64data = reader.result.split(",")[1];
          resolve(base64data);
        };
        reader.readAsDataURL(blob);
      });

      setBlobString(blobAsBase64);
    } catch (error) {
      console.error(error);
    }
  };

  // Gerar Imagems
  async function handleGenerateGraphPNG({ chart, width = 790, height = 200 }) {
    let staticHtmlTraffic = renderToStaticMarkup(chart);
    let graphc = await handleApiGetBase64({
      data: btoa(unescape(encodeURIComponent(staticHtmlTraffic))),
      width: width,
      height: height,
    });
    return graphc;
  }
  async function handleApiGetBase64(htmlBase64) {
    try {
      const response = await api.post("/cliente/relatorio/htmlToImageBase64", {
        htmlBase64,
      });

      if (response.data) {
        return response.data;
      }
    } catch (error) {
      throw error;
    }
  }
  async function handleUrlToBase64({ url, options = {} }) {
    try {
      const response = await api.post("/cliente/relatorio/urlToImageBase64", {
        url,
        options,
      });

      if (response.data) {
        return response?.data;
      }
    } catch (error) {
      console.error("Error: ", error);
      return null;
    }
  }

  const WrapPieChart = ({ data }) => {
    return (
      <PDFPieChart
        data={[
          { name: "Disponível", value: parseFloat(data) },
          { name: "Indisponível", value: 100 - parseFloat(data) },
        ]}
        theme={theme}
      />
    );
  };

  return (
    <>
      <Box id="pdf">{blobString && blobString}</Box>
    </>
  );
}
